export enum ErrorCodes {
  GeneralError = 'ERROR_MSG_GENERAL',
  FormErrorEmptyField = 'FORM_ERROR_EMPTY_FIELD',
}
